<div class="notification-setup-container">
  <div class="notification-setup-content">
    <lr-notification-preferences-form
      layout="callback"
      [form]="notificationForm"
      [preferences]="notificationPreferences()"
      [companyName]="companyDisplayName()"
      [hasMultipleCompanies]="hasMultipleCompanies()"
      [isLoading]="isLoading()"
      [isSaving]="isSaving()"
      [errorMessage]="errorMessage()"
      [showSkip]="true"
      (save)="onSave()"
      (skip)="onSkip()" />
  </div>
</div>
